export default "__VITE_ASSET__CubBtaEt__"